<template>
  <li class="dk-navbar__nav-item">
    <button
      v-if="isDesktop"
      class="dk-navbar__nav-item-link"
      :class="{
        'dk-navbar__nav-item-link--expanded': isExpanded,
      }"
      @click="$emit('clickLocationSwitcher')"
      :aria-label="$t('location.country.label')"
    >
      <DKIcon icon="globe" :width="20"></DKIcon>
    </button>
    <Megamenu
      v-show="isExpanded"
      type="secondary"
      :isTransparent="true"
      :isExpanded="isExpanded"
      :isFull="true"
    >
      <MegamenuLocationOverview
        :locationGroups="locationGroups"
        :contactNavigationTree="contactNavigationTree"
        @clickLocationLink="$emit('clickLocationLink', $event)"
      ></MegamenuLocationOverview>
    </Megamenu>
  </li>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-facing-decorator';
import {
  enablePageScroll,
  disablePageScroll,
} from '@/helpers/page-scroll-helper';
import Megamenu from '@/components/navbar/Megamenu.vue';
import MegamenuLocationOverview from '@/components/navbar/MegamenuLocationOverview.vue';
import { LocationGroup } from '@/store/navigation/models/LocationGroup';
import { DKIcon } from '@dormakaba/dormakaba-components';
import { useMq } from 'vue3-mq';
import { NavigationTree } from '@/store/navigation/models/NavigationTree';

@Component({
  components: {
    DKIcon,
    Megamenu,
    MegamenuLocationOverview,
  },
  emits: ['clickLocationSwitcher', 'clickLocationLink'],
})
export default class NavbarLocationSwitcher extends Vue {
  @Prop({ default: false }) isExpanded!: boolean;
  @Prop({ default: [] }) locationGroups!: LocationGroup[];
  @Prop({ default: [] }) contactNavigationTree: NavigationTree = [];

  get isDesktop(): boolean {
    return this.$isDesktop(this.$mq);
  }

  created() {
    this.$mq = useMq();
  }

  mounted() {
    this.$watch(
      () => this.isExpanded,
      () => {
        if (this.isExpanded) {
          disablePageScroll(window.scrollY);
        } else {
          const scrollPosition = document.body.getBoundingClientRect().top;
          enablePageScroll();
          window.scrollTo(0, scrollPosition);
        }
      }
    );
  }

  onEmit(eventName: string) {
    setTimeout(() => {
      this.$emit(eventName);
    });
  }
}
</script>
<style lang="postcss" scoped>
.dk-navbar__nav-item {
  & .dk-navbar__nav-item-link--expanded {
    @apply duration-400;
  }
}
</style>
